import type { TransactionCurrency } from '@contracts/payment/Currency';
import type { CurrencyField } from '@src/clients/financialSettings/fields/CurrencyFields';
import { StringField } from '@src/permitField/PermitFields';
import type { StringSchema } from 'yup';
import * as yup from 'yup';

// deprecated
export class CreditCardNumberField extends StringField {
  public static fieldName = 'cardNumber' as const;
}

// deprecated
export class ExpirationField {
  public static fieldName = 'expiration' as const;
  public static validator: StringSchema = yup
    .string()
    .trim()
    .typeError('isExpiration')
    .test('is-expiration', 'isExpiration', (expiration) => {
      if (expiration) {
        return /^(0[1-9]|1[0-2])\/\d{2}$/.test(expiration); // format MM/YY
      }
      return true;
    })
    .required();
}

// deprecated
export class CvvField extends StringField {
  public static fieldName = 'cvv' as const;
}

export class NameOnCardField extends StringField {
  public static fieldName = 'nameOnCard' as const;
}

export class EmailField extends StringField {
  public static fieldName = 'email' as const;
}

export class FirstNameField extends StringField {
  public static fieldName = 'firstName' as const;
}

export class LastNameField extends StringField {
  public static fieldName = 'lastName' as const;
}

export class AddressField extends StringField {
  public static fieldName = 'address' as const;
}

export class AddressLine2Field {
  public static fieldName = 'addressLine2' as const;
}

export class ZipField {
  public static fieldName = 'zip' as const;
  public static validator: StringSchema = yup
    .string()
    .trim()
    .typeError('isZip')
    .test('is-zip', 'isZip', (zip) => {
      if (zip) {
        return zip.length >= 1 && zip.length <= 10;
      }
      return true;
    })
    .required();
}

export class CityField extends StringField {
  public static fieldName = 'city' as const;
}

export class CountryCodeField extends StringField {
  public static fieldName = 'countryCode' as const;
}

export class StateField extends StringField {
  public static fieldName = 'state' as const;
}

export interface CreditCardFields {
  [CurrencyField.fieldName]: keyof typeof TransactionCurrency;
  [NameOnCardField.fieldName]: string;
  [EmailField.fieldName]: string;
  [FirstNameField.fieldName]: string;
  [LastNameField.fieldName]: string;
  [AddressField.fieldName]: string;
  [AddressLine2Field.fieldName]?: string;
  [ZipField.fieldName]: string;
  [CityField.fieldName]: string;
  [CountryCodeField.fieldName]: string;
  [StateField.fieldName]: string;
}

export class SaveCardOnFileField {
  public static fieldName = 'saveCardOnFile' as const;
  public static validator = yup.boolean().required();
}
